import { render, staticRenderFns } from "./commentaires.vue?vue&type=template&id=e683d5a8&scoped=true"
import script from "./commentaires.vue?vue&type=script&lang=js"
export * from "./commentaires.vue?vue&type=script&lang=js"
import style0 from "./commentaires.vue?vue&type=style&index=0&id=e683d5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e683d5a8",
  null
  
)

export default component.exports